var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title:
              _vm.$t("CargoMsg.Cargo_SettleAccountsTo") +
              _vm.$t("CargoMsg.Cargo_Details"),
            width: "900px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "el-row",
                            [
                              _vm._v(" ` "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_ContractRule")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "183px" },
                                      attrs: {
                                        value: _vm.currentContract.uuid,
                                        no: "contractRuleUuid"
                                      },
                                      on: { change: _vm.contractChange }
                                    },
                                    _vm._l(_vm.contractList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label:
                                            item.ruleName +
                                            (item.contractNo
                                              ? "【" + item.contractNo + "】"
                                              : ""),
                                          value: item.uuid
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v("` ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: "",
                            disabled: "",
                            "label-width": "80px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Partners.credit_dateType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "183px" },
                                  attrs: { no: "1" },
                                  model: {
                                    value: _vm.currentOnlyCreditInfo.remarks,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentOnlyCreditInfo,
                                        "remarks",
                                        $$v
                                      )
                                    },
                                    expression: "currentOnlyCreditInfo.remarks"
                                  }
                                },
                                _vm._l(_vm.DATETYPE_TYPE, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.$getLangColumn(item),
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Partners.credit_settlementMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { no: "2" },
                                  model: {
                                    value: _vm.cbType,
                                    callback: function($$v) {
                                      _vm.cbType = $$v
                                    },
                                    expression: "cbType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "Partners.credit_monthlySettlement"
                                      ),
                                      value: -1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_space3"),
                                      value: -2
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_space4"),
                                      value: "n"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_space5"),
                                      value: -3
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.dailySettlement"),
                                      value: -4
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _vm.cbType === "n"
                                ? _c("el-input-number", {
                                    staticStyle: { width: "100px" },
                                    attrs: { controls: false, no: "3" },
                                    model: {
                                      value:
                                        _vm.currentOnlyCreditInfo
                                          .creditDateType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.currentOnlyCreditInfo,
                                          "creditDateType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "currentOnlyCreditInfo.creditDateType"
                                    }
                                  })
                                : _vm._e(),
                              _vm.isShowBlacklist
                                ? _c("el-checkbox", {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "Partners.credit_blacklist"
                                      ),
                                      no: "4"
                                    },
                                    model: {
                                      value: _vm.creditInfo.blacklist,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.creditInfo,
                                          "blacklist",
                                          $$v
                                        )
                                      },
                                      expression: "creditInfo.blacklist"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("br"),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Partners.credit_accountPeriod")
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100px" },
                                attrs: { controls: false, no: "5" },
                                model: {
                                  value:
                                    _vm.currentOnlyCreditInfo.creditDateLimited,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.currentOnlyCreditInfo,
                                      "creditDateLimited",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "currentOnlyCreditInfo.creditDateLimited"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "80px",
                                    "margin-left": "3px"
                                  },
                                  attrs: { no: "6" },
                                  model: {
                                    value: _vm.currentOnlyCreditInfo.termUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentOnlyCreditInfo,
                                        "termUnit",
                                        $$v
                                      )
                                    },
                                    expression: "currentOnlyCreditInfo.termUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.credit_month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Partners.credit_limit") }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100px" },
                                attrs: { controls: false, no: "7" },
                                model: {
                                  value: _vm.currentOnlyCreditInfo.credit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.currentOnlyCreditInfo,
                                      "credit",
                                      $$v
                                    )
                                  },
                                  expression: "currentOnlyCreditInfo.credit"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "100px",
                                    "margin-left": "3px"
                                  },
                                  attrs: { no: "8" },
                                  model: {
                                    value: _vm.currentOnlyCreditInfo.currency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentOnlyCreditInfo,
                                        "currency",
                                        $$v
                                      )
                                    },
                                    expression: "currentOnlyCreditInfo.currency"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "RMB", value: "RMB" }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "USD", value: "USD" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("br"),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                disabled: "",
                                label: _vm.$t("Partners.credit_settlementType"),
                                no: "9"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: true },
                                  model: {
                                    value: _vm.settlementByBill,
                                    callback: function($$v) {
                                      _vm.settlementByBill = $$v
                                    },
                                    expression: "settlementByBill"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Partners.credit_settlementByBill")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: true },
                                  model: {
                                    value: _vm.settlementNotByBill,
                                    callback: function($$v) {
                                      _vm.settlementNotByBill = $$v
                                    },
                                    expression: "settlementNotByBill"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Partners.credit_settlementNotByBill"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "100%",
                                  "max-height": "400px"
                                },
                                attrs: {
                                  type: "textarea",
                                  rows: 6,
                                  placeholder: ""
                                },
                                model: {
                                  value: _vm.newCreditInfo.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newCreditInfo, "remark", $$v)
                                  },
                                  expression: "newCreditInfo.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    "margin-bottom": "8px"
                  },
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_OverdueExpenses"),
                        name: "otherDocuments"
                      }
                    },
                    [
                      _c(
                        "el-form",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("span", [_vm._v(_vm._s(_vm.lbLine))]),
                              _c("span", { staticStyle: { margin: "0 5px" } }, [
                                _vm._v(_vm._s(_vm.lbSum))
                              ]),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    width: "20px"
                                  },
                                  attrs: { type: "primary", no: "16" },
                                  on: { click: _vm.onRefreshCharge }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Refresh"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    width: "20px"
                                  },
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.enableNegelect,
                                    no: "17"
                                  },
                                  on: { click: _vm.onNeglect }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Ignore"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    width: "20px"
                                  },
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.enableNegelectRollback,
                                    no: "18"
                                  },
                                  on: { click: _vm.onNeglectRollback }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CancelIgnore")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row row-grid",
                          staticStyle: { "min-height": "300px" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-side-bar": false,
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData,
                              no: "19"
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_TempCredit"),
                        name: "tempCredit"
                      }
                    },
                    [
                      _vm.$checkPermission([
                        "button_tabSettleAccountList_syncCredit"
                      ])
                        ? _c(
                            "el-form",
                            { staticStyle: { "margin-top": "5px" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        no: "syncCredit"
                                      },
                                      on: { click: _vm.syncCreditHandler }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.Synchronization")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.$t(
                                          "CargoMsg.Cargo_SyncCreditTip"
                                        )
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning",
                                        staticStyle: {
                                          color: "#e6a23c",
                                          "margin-left": "5px"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row row-grid",
                          staticStyle: { "min-height": "300px" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: {
                              height: "100%",
                              "min-height": "220px"
                            },
                            attrs: {
                              "column-defs": _vm.tempCreditColumnDefs,
                              "grid-options": _vm.tempCreditInfo.gridOptions,
                              "row-data": _vm.tempCreditInfo.rowData,
                              "show-side-bar": false
                            },
                            on: { rowDataChanged: _vm.rowDataChanged }
                          })
                        ],
                        1
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_TempCreditNotice"))
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_SpecialApprovalIssuance"),
                        name: "specialApprovalIssuance"
                      }
                    },
                    [
                      _c(
                        "el-form",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_CurrentAvailableQuantity"
                                )
                              }
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  no: "numberAllocationLimit",
                                  precision: 0,
                                  controls: false,
                                  min: 0,
                                  max: 999999999999
                                },
                                model: {
                                  value:
                                    _vm.partnerNumberAllocation
                                      .numberAllocationLimit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.partnerNumberAllocation,
                                      "numberAllocationLimit",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "partnerNumberAllocation.numberAllocationLimit"
                                }
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "CargoMsg.Cargo_SpecialApprovalCreateBusiness"
                                    )
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning",
                                    staticStyle: {
                                      color: "#e6a23c",
                                      "margin-left": "5px"
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row row-grid",
                          staticStyle: { "min-height": "300px" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-side-bar": false,
                              "grid-options":
                                _vm.partnerNumberAllocationRecordGrid
                                  .gridOptions,
                              "column-defs":
                                _vm.partnerNumberAllocationRecordGrid
                                  .columnDefs,
                              "row-data":
                                _vm.partnerNumberAllocationRecordGrid.rowData
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.partnerNumberAllocationRecordGrid.gridApi =
                                  params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("hr"),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: "",
                    disabled: !_vm.canEditCredit,
                    "label-width": "80px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "Partners.credit_revenueAndExpenditureType"
                        )
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "10" },
                          model: {
                            value: _vm.creditInfo.receivableDeposit,
                            callback: function($$v) {
                              _vm.$set(_vm.creditInfo, "receivableDeposit", $$v)
                            },
                            expression: "creditInfo.receivableDeposit"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(
                              _vm._s(_vm.$t("Partners.credit_collections"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("Partners.credit_payment")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.credit_depositAmount") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100px" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          max: 9999999,
                          no: "11"
                        },
                        model: {
                          value: _vm.creditInfo.depositAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.creditInfo, "depositAmount", $$v)
                          },
                          expression: "creditInfo.depositAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "Partners.credit_revenueAndExpenditureDate"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100px" },
                        attrs: { format: "yyyy-MM-dd", no: "12" },
                        model: {
                          value: _vm.creditInfo.depositDate,
                          callback: function($$v) {
                            _vm.$set(_vm.creditInfo, "depositDate", $$v)
                          },
                          expression: "creditInfo.depositDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "Partners.credit_revenueAndExpenditureMethod"
                        )
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "134px" },
                          attrs: { no: "13" },
                          model: {
                            value: _vm.creditInfo.depositType,
                            callback: function($$v) {
                              _vm.$set(_vm.creditInfo, "depositType", $$v)
                            },
                            expression: "creditInfo.depositType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_cash"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_space6"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_space7"),
                              value: 2
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_space8"),
                              value: 3
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_space9"),
                              value: 4
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.credit_space10"),
                              value: 5
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.credit_depositCurrency")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { no: "14" },
                          model: {
                            value: _vm.creditInfo.depositCurrency,
                            callback: function($$v) {
                              _vm.$set(_vm.creditInfo, "depositCurrency", $$v)
                            },
                            expression: "creditInfo.depositCurrency"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "RMB", value: "RMB" }
                          }),
                          _c("el-option", {
                            attrs: { label: "USD", value: "USD" }
                          }),
                          _c("el-option", {
                            attrs: { label: "HKD", value: "HKD" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.credit_additionalDescription")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "700px" },
                        attrs: {
                          disabled: !_vm.canEditCredit,
                          type: "textarea",
                          rows: "10",
                          no: "15"
                        },
                        model: {
                          value: _vm.creditInfo.creditRmarks,
                          callback: function($$v) {
                            _vm.$set(_vm.creditInfo, "creditRmarks", $$v)
                          },
                          expression: "creditInfo.creditRmarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveEventHandler(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          },
          close: function($event) {
            _vm.innerVisible = false
            _vm.$emit("handleSaved")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }